<template>
    <div class="advantage">
        <div class="main">
            <div class="titbox">
                <h3>亮点介绍</h3>
                <!-- <p>实现异构、异主、异地数据便捷、安全、可控、开放的互联互通与安全共享，帮助机构、企业降低成本、提升效率，提升安全性</p> -->
            </div>
            <div class="cardList_box">
                <div class="cardList_item">
                    <span class="cardList_item_title">基础设施</span>
                    <ul class="cardList_item_detail">
                        <li>
                            <i class="u-icon-check"></i>
                            支持数字经济发展
                        </li>
                        <li>
                            <i class="u-icon-check"></i>
                            数据要素流通、数联网
                        </li>
                        <li>
                            <i class="u-icon-check"></i>
                            新型数据基础设施
                        </li>
                    </ul>
                    <img class="cardList_item_bg" src="./../../assets/img/products/data/jcICON1.png" alt="">
                </div>
                <div class="cardList_item">
                    <span class="cardList_item_title">全球架构</span>
                    <ul class="cardList_item_detail">
                        <li>
                            <i class="u-icon-check"></i>
                            全球分布式管理架构
                        </li>
                        <li>
                            <i class="u-icon-check"></i>
                            12个并联根节点平等协商共管共治
                        </li>
                        <li><i class="u-icon-check"></i>
                            提供面向全球范围公共服务
                        </li>
                    </ul>
                    <img class="cardList_item_bg" src="./../../assets/img/products/data/jcICON2.png" alt="">
                </div>
                <div class="cardList_item">
                    <span class="cardList_item_title">国家认可</span>
                    <ul class="cardList_item_detail">
                        <li><i class="u-icon-check"></i>
                            国家级单位牵头
                        </li>
                        <li><i class="u-icon-check"></i>
                            中国自主根节点
                        </li>
                        <li><i class="u-icon-check"></i>
                            国内首张根节点运营许可
                        </li>
                        <li><i class="u-icon-check"></i>
                            标识管理机构运营许可
                        </li>
                    </ul>
                    <img class="cardList_item_bg" src="./../../assets/img/products/data/jcICON3.png" alt="">
                </div>
                <div class="cardList_item">
                    <span class="cardList_item_title">兼容互通</span>
                    <ul class="cardList_item_detail">
                        <li><i class="u-icon-check"></i>
                            支持数据跨网、跨域、跨平台流通
                        </li>
                        <li><i class="u-icon-check"></i>
                            兼容各类公/私有技术
                        </li>
                        <li><i class="u-icon-check"></i>
                            兼容各类数字对象
                        </li>
                    </ul>
                    <img class="cardList_item_bg" src="./../../assets/img/products/data/jcICON4.png" alt="">
                </div>
                <div class="cardList_item">
                    <span class="cardList_item_title">安全可控</span>
                    <ul class="cardList_item_detail">
                        <li><i class="u-icon-check"></i>
                            内生信息管理、内生安全控制
                        </li>
                        <li><i class="u-icon-check"></i>
                            全球身份认证、信息自主管理
                        </li>
                        <li><i class="u-icon-check"></i>
                            保障数据主权、保障传输安全
                        </li>
                        <li><i class="u-icon-check"></i>
                            兼容适配信创产品
                        </li>
                    </ul>
                    <img class="cardList_item_bg" src="./../../assets/img/products/data/jcICON5.png" alt="">
                </div>
                <div class="cardList_item">
                    <span class="cardList_item_title">稳定创新</span>
                    <ul class="cardList_item_detail">
                        <li><i class="u-icon-check"></i>
                            稳定运行十余年
                        </li>
                        <li><i class="u-icon-check"></i>
                            自主创新研发增强版系统
                        </li>
                        <li><i class="u-icon-check"></i>
                            提供开发工具箱
                        </li>
                    </ul>
                    <img class="cardList_item_bg" src="./../../assets/img/products/data/jcICON6.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Advantage',
  data () {
    return {}
  }
}
</script>

<style lang="less">
.advantage{
    width: 100%;
    background-color: #f7f9fc;
    .main {
        width:1200px;
        margin:auto;
        padding-bottom: 56px;
        .titbox{
            width: 100%;
            text-align: center;
            color:#333;
            padding:70px 0;
            h3{
                font-size: 36px;
                line-height: 1.3;
            }
            p{
                font-size: 16px;
                color:#666;
                margin-top:15px
            }
        }
        .cardList_box{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: space-between;
            .cardList_item{
                width: 373px;
                height: 288px;
                padding: 32px 0 0 32px;
                box-sizing: border-box;
                border-radius: 4px;
                margin-bottom: 40px;
                position: relative;
                overflow: hidden;
                background: #fff;
                z-index: 0;
                .cardList_item_title {
                    display: block;
                    font-weight: 600;
                    font-size: 24px;
                    line-height: 34px;
                    color: #03081a;
                    margin-bottom: 28px;
                    transition: all 333ms ease;
                }
                .cardList_item_detail {
                    li{
                        display: flex;
                        align-items: center;
                        font-size: 16px;
                        line-height: 1;
                        color: #495366;
                        margin-bottom: 19px;
                        transition: all 333ms ease;
                        i{
                            width: 6px;
                            height: 6px;
                            border-radius: 50%;
                            display: inline-block;
                            background-color: #0065dd;
                            margin-right: 7px;
                            transition: all 333ms ease;
                        }
                    }
                }
                .cardList_item_bg{
                    position: absolute;
                    width: 146px;
                    height: auto;
                    right: 0;
                    bottom: -53px;
                    transition: all 333ms ease;
                }
            }
            .cardList_item::before{
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                z-index: -1;
                box-shadow: 0 5px 20px rgba(0,74,211,.2);
                background: linear-gradient(141.26deg, #5c98ff 11.93%, #256bf9 106.17%);
                opacity: 0;
                transition: all 333ms ease;
            }
            .cardList_item:hover::before{
                opacity: 1;
            }
            .cardList_item:hover .cardList_item_bg{
                bottom: 0;
            }
            .cardList_item:hover .cardList_item_title{
                color: #fff;
            }
            .cardList_item:hover .cardList_item_detail li{
                color: #fff;
            }
            .cardList_item:hover .cardList_item_detail li i{
                background-color: #fff;
            }
        }
    }
}
@media screen and (max-width:1000px) {
    .products{
        .main {
            width:100%;
            .cardList{
                width: 100%;
                .cardList_item{
                    display:block ;
                    li {
                        width:100%;
                        margin:15px 0 20px 0;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/Home/components/Advantage.vue